export default __webpack_public_path__ + "static/hub-stile-x-a399a36450e174d1fbbe7b2637e9b972.jpg";